import { render, staticRenderFns } from "./ParentSection.vue?vue&type=template&id=7b374d06&scoped=true&"
import script from "./ParentSection.vue?vue&type=script&lang=js&"
export * from "./ParentSection.vue?vue&type=script&lang=js&"
import style0 from "./ParentSection.vue?vue&type=style&index=0&id=7b374d06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b374d06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VChip,VIcon,VList,VListItem,VListItemTitle,VMenu,VTextField})
